import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  RegisterMain,
  RegisterCard,
  SigninToggle,
  RememberMe,
  RegisterDiv,
} from "./AuthStyles";
import PasswordInput from "../../components/PasswordInput";
import Header from "../../components/Header";
import MobileNav from "../../components/MobileNav";
import Footer from "../../components/Footer";

const Signin = () => {
  const [toggleBtn, setToggleBtn] = useState(1);

  const toggleTab = (index) => {
    setToggleBtn(index);
  };
  return (
    <div className="bg">
      <Header />
      <MobileNav />
      <RegisterMain>
        <RegisterCard>
          <SigninToggle>
            <Link
              to="/sign-in"
              className={toggleBtn === 1 ? "activeBorder" : "borderBottom"}
              onClick={() => {
                toggleTab(1);
              }}
            >
              Sign In
            </Link>
            <Link
              to="/sign-up"
              className={toggleBtn === 2 ? "activeBorder" : "borderBottom"}
              onClick={() => {
                toggleTab(2);
              }}
            >
              Sign Up
            </Link>
          </SigninToggle>
          <RegisterDiv>
            <div className="formDiv">
              <label>Email Id*</label>
              <input type="email" />
            </div>
            <label>Password*</label>
            <PasswordInput />
            <RememberMe>
              <div>
                <input type="checkbox" />
                Remember Me
              </div>
              <div>
                <Link to="/forgot-password">Forgot Password</Link>
              </div>
            </RememberMe>
            <button>Sign In</button>
          </RegisterDiv>
        </RegisterCard>
      </RegisterMain>
      <Footer />
    </div>
  );
};

export default Signin;
